/**
 * This is the entry file for webpack/config/front.js
 */


// Nette forms
import netteForms from 'nette-forms';
window.Nette = netteForms;
netteForms.initOnLoad();

// Cookies
import '/node_modules/vanilla-cookieconsent/dist/cookieconsent.js';

// Icons
import '/node_modules/feather-icons/dist/feather.min';

// Application
import '/webpack/assets/js/front/flashMessenger.js';
import '/webpack/assets/js/front/netteFormsExtension.js';
import '/webpack/assets/js/front/general.js';
